export const N_YEARS = 30; // Number of years of data available.
export const CURRENT_YEAR = new Date().getFullYear();
export const MULTI_YEAR = 'multi-year';
export const MULTI_YEAR_FILTERS = [5, 10, 15, 20, 30];
export const ANNUAL_MULTI_YEAR = 'annual-multi-year';
export const ANNUAL_MULTI_YEAR_FILTERS = [5, 30];
